import {
    FETCH_BALANCE,
    ADD_BALANCE
} from "../../constants/ActionTypes";

export const fetchBalance = () => ({type: FETCH_BALANCE});
export const addBalance = value => ({type: ADD_BALANCE, value});
